<template>
  <ion-card
    color="white py-lg px-sm"
    class="border-default no-shadow ion-no-margin d-flex flex-column ion-align-items-center"
  >
    <ion-img :src="HomeSearch" alt="Arribo Hero" class="no-data-img"></ion-img>
    <h2 class="font-lg bold-medium text-align-center">
      {{ t('bookingDetails.weDidntFind') }}
    </h2>
    <p class="font-sm text-align-center">
      {{ t('bookingDetails.makeChanges') }}
    </p>
  </ion-card>
</template>

<script setup lang="ts">
  import { IonCard, IonImg } from '@ionic/vue';
  import HomeSearch from '@/assets/images/Home-Search.svg';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<style lang="css" scoped>
  .no-data-img {
    width: 100%;
    max-width: 400px;
  }
</style>
